import React, { useEffect, useState } from "react";
import { GameClubHeaderWrapper, GameClubTabWrapper } from "../Style/GameStyles";
import { ClubTab } from "../Hook/useGameClub";
import { useGameClubContext } from "../Hook/GameClubContext";

export interface GameClubHeaderProps {
  isCalendarOpen: boolean;
  setIsCalendarOpen: (isCalendarOpen: boolean) => void;
}

export const GameClubHeader: React.FC<GameClubHeaderProps> = ({
  isCalendarOpen,
  setIsCalendarOpen,
}) => {
  const { isGameClubTab, setGameClubTab, gameClubTab } = useGameClubContext();

  return (
    <GameClubHeaderWrapper>
      <div className="title-wrapper">
        <img
          src="/image-web/game/club/back.svg"
          alt="back"
          onClick={() => {
            setGameClubTab(ClubTab.MY);
          }}
        />
        <div className="title">
          {isGameClubTab(ClubTab.MEMBER) ? "클럽 유저" : "클럽 채팅"}
        </div>
      </div>

      {isGameClubTab(ClubTab.MEMBER) && (
        <img
          src="/image-web/game/club/filter.svg"
          alt="filter"
          onClick={() => setIsCalendarOpen(true)}
        />
      )}
    </GameClubHeaderWrapper>
  );
};
